<template>
  <section class="mt-6 lg:mt-8">
    <div class="container">
      <StaticticsIndex :statisticsData="currentData?.statistics" v-if="user.role_name !== 'author'&& user.role_name !== 'publisher'"/>
      <AuthorBlocks :statisticsDataAuthor="currentData?.statistics_author" v-if="user.role_name == 'author'&& user.role_name !== 'publisher'"/>
      <PublisherBlocks :statisticsDataPublisher="currentData?.statistics_Publisher" v-if="user.role_name == 'publisher'" />

      <div class="grid grid-cols-1 md:grid-cols-10 my-10 gap-5 lg:gap-7 bg-white" v-if="user.role_name == 'author'">
          <div class="col-span-4 m-10">
              <TopBook :topBookData="currentData?.topFiveBooks"/>
          </div>
          <div class="col-span-6 p-10 mt-20">
              <ChartSales :barChart="currentData?.barChart" />
          </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-10 my-10 gap-5 lg:gap-7 bg-white mt-10" v-if="user.role_name == 'author'">
          <div class="col-span-4 m-10">
              <LatestBooks :LatestBooks="currentData?.latestbook"/>
          </div>
          <div class="col-span-6 p-10 mt-20">
              <DonatChartSales  :topFiveTitle="currentData?.topFiveTitle" :topSales="currentData?.topSales" />
              <!--<ChartSales  :topBookTitles="currentData?.topFiveTitle" :topSalesCounts="currentData?.topSales" />-->
          </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-10 my-10 gap-5 lg:gap-7 bg-white" v-if="user.role_name == 'publisher'">
          <div class="col-span-4 m-10">
              <TopBook :topBookData="currentData?.topFiveBooksPublisher"/>
          </div>
          <div class="col-span-6 p-10 mt-20">
              <ChartSales :barChart="currentData?.barChartPublisher" />
          </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-10 my-10 gap-5 lg:gap-7 bg-white mt-10" v-if="user.role_name == 'publisher'">
          <div class="col-span-4 m-10">
              <LatestBooks :LatestBooks="currentData?.latestbookPublisher"/>
          </div>
          <div class="col-span-6 p-10 mt-20">
              <DonatChartSales  :topFiveTitle="currentData?.topFiveTitlePublisher" :topSales="currentData?.topSalesPublisher" />
              <!--<ChartSales  :topBookTitles="currentData?.topFiveTitle" :topSalesCounts="currentData?.topSales" />-->
          </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 my-10 gap-5 lg:gap-7" v-if="user.role_name !== 'author' && user.role_name !== 'publisher'">
      </div>
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-5 lg:gap-7" v-if="user.role_name !== 'author' && user.role_name !== 'publisher'">
        <!-- box - 1  -->
        <div  class="w-full main-card px-3 p-3">
          <h3 class="text-lg font-bold text-center mb-4">SUBSCRIBES</h3>
          <div>Maillist</div>
           <maillistTable :currentMaillist="currentData?.mail_list?.data" />
        </div>

        <!-- box - 2  -->
        <div v-if="currentData?.logs" class="w-full main-card px-3 p-3">
          <h3 class="text-lg font-bold text-center mb-4">Logs</h3>
          <div>Log</div>
          <logTimeLine :currentLogs="currentData?.logs?.data" />
        </div>

        <div v-if="currentData?.visitor_messages" class="lg:col-span-2 w-full main-card px-3 p-3">
          <h3 class="text-lg font-bold text-center mb-4">Messages</h3>
          <div>Current Messages</div>
          <MessageTable :currentMessages="currentData?.visitor_messages?.data" />
        </div>

      </div>

      <DashStatsQuery />
    </div>
  </section>
</template>

<script>
import DashStatsQuery from '@/services/queries/dash/DashStatsQuery.vue';
import logTimeLine from './blocks/logTimeLine.vue';
import maillistTable from './blocks/maillistTable.vue';
import StaticticsIndex from './blocks/StaticticsIndex.vue';
import MessageTable from './blocks/MessageTable.vue';
import AuthorBlocks from './blocks/AuthorBlocks.vue';
import ChartSales from './ChartSales.vue';
import TopBook from './blocks/TopBook.vue';
import DonatChartSales from './DonatChartSales.vue';
import LatestBooks from './blocks/LatestBooks.vue';
import PublisherBlocks from './blocks/PublisherBlocks.vue';

export default {
  components: {
    DashStatsQuery,
    logTimeLine,
    StaticticsIndex,
    maillistTable,
    MessageTable,
    AuthorBlocks,
    ChartSales,
    DonatChartSales,
    TopBook,
    LatestBooks,
    PublisherBlocks,
  },
  data() {
    return {
      pageNum: 1,
      perPage: 10,
    };
  },
  watch: {},
  computed: {
    dashQuery() {
      return this.$store.state.dash.dashStatsQuery;
    },
    currentData() {
      const q = this.$store.state.dash.dashStatsQuery;
      if (!q || q.isLoading || q.isError) {
        return [];
      }
      console.log(q.data);
      return q.data?.data;
    },
    user() {
      return this.$store.state.auth.user || null;
    },
  },
  methods: {},
  created() {},
};
</script>

<style lang="scss" scoped></style>
